import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core';
import TextFieldMUI from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = {
  textField: {
    width: '100%',
    maxHeight: 56,
  },
  textFieldBase: {
    background: 'rgba(31, 38, 107, 0.1)',
    '& input': {
      borderColor: 'transparent',
    },
  },
  textFieldDisabled: {
    backgroundColor: 'rgba(31, 38, 107, 0.08)',
  },
  input: {
    height: 56,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    border: '1px solid rgba(0, 0, 0, 0.32)',
    borderRadius: '5px',
    fontSize: 17,
    letterSpacing: 0.2,
    color: '#1f266b',
    transition: '0.25s all',
    '&:focus': {
      border: '2px solid #1f266b',
    },
  },
  inputRoot: {
    minHeight: 56,
    height: 56,
    marginTop: '0!important',
  },
  formLabel: {
    fontSize: 17,
    letterSpacing: 0.2,
    color: '#1f266b',
  },
  labelAnimated: {
    transform: 'translate(16px, 14px) scale(1)',
    padding: 6,
  },
  labelShrink: {
    transform: 'translate(16px, -11px) scale(0.8)',
    color: 'rgba(0, 0, 0, 0.6)',
    background: '#fff',
    zIndex: 1,
  },
  helperText: {
    color: '#1f266b',
    margin: '8px 0 0 15px',
  },
  buttonIcon: {
    position: 'absolute',
    right: 20,
    top: 0,
  },
};

const StyledTextField = styled.div`
  position: relative;
`;

const ButtonWrap = styled.div`
  position: absolute;
  right: 10px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
`;

const TextField = ({
  classes,
  label,
  base,
  disabled,
  showPassword,
  togglePasswordVisibility,
  ...rest
}) => {
  const { type } = rest;
  const inputType = (type === 'password' && showPassword) ? 'text' : type;

  const className = classnames(
    classes.textField,
    { [classes.textFieldBase]: base },
    { [classes.textFieldDisabled]: disabled },
  );

  return (
    <StyledTextField>
      <TextFieldMUI
        {...rest}
        type={inputType}
        label={label}
        className={className}
        disabled={disabled}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: classes.inputRoot,
            input: classes.input,
          },
        }}
        InputLabelProps={{
          className: classes.formLabel,
          classes: {
            animated: classes.labelAnimated,
            shrink: classes.labelShrink,
          },
        }}
        FormHelperTextProps={{
          className: classes.helperText,
        }}
      />

      {type === 'password' && (
        <ButtonWrap>
          <IconButton
            aria-label="Toggle password visibility"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </ButtonWrap>
      )}
    </StyledTextField>
  );
};

export default withStyles(styles)(TextField);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/TextField.jsx